<span *ngIf="alertsService.alertCount !== 0" class="badge badge-error">{{alertsService.alertCount | alertCounter }}</span>
<span *ngIf="alertsService.alertCount === 0" class="sr-only">No Alerts</span>
<span *ngIf="alertsService.alertCount === 1" class="sr-only">Alert</span>
<span *ngIf="alertsService.alertCount >= 2" class="sr-only">Alerts</span>
